<script setup lang="ts">
  import { watch } from 'vue'
  import { useRoute } from 'vue-router'
  import { useAuthLogout } from '@/models/auth'
  import { useAuthStore } from '@/stores/auth'
  import SidebarHeader from './sidebar-header.vue'
  import SidebarItems from './sidebar-items.vue'
  // import SidebarSearch from './sidebar-search.vue'

  const props = defineProps<{
    show: boolean,
  }>()

  const emit = defineEmits<{
    (e: 'toggleSidebarShow'): void,
    (e: 'toggleSidebarSize'): void,
  }>()

  const route = useRoute()
  watch(
    () => route.fullPath,
    () => {
      if (props.show) {
        emit('toggleSidebarShow')
      }
    },
  )

  const auth = useAuthStore()
  const logout = useAuthLogout()
</script>

<template>
  <div>
    <div
      class="sidebar-dimmer"
      @click="emit('toggleSidebarShow')"></div>

    <nav class="sidebar">
      <sidebar-header
        class="sidebar-header"
        @toggle-sidebar-show="emit('toggleSidebarShow')"
        @toggle-sidebar-size="emit('toggleSidebarSize')" />

      <hr class="mx-3.5">

      <!-- <sidebar-search class="lg:hidden" /> -->

      <sidebar-items class="sidebar-content" />

      <div class="px-4 py-2">
        <div class="flex rounded-lg items-center gap-4 bg-sidebar-item py-2 px-4 text-white relative">
          <!-- <div>
            <div class="size-10 rounded-full bg-white"></div>
          </div> -->

          <div class="flex-1 min-w-0">
            <div class="truncate">
              {{ auth.user.name }}
            </div>
            <div class="text-xs">
              {{ auth.user.role }}
            </div>
          </div>

          <app-button
            title="Keluar"
            class="text-xl leading-0"
            @click="logout()">
            <fa-icon icon="i-far-arrow-right-from-bracket" />
          </app-button>
        </div>
      </div>
    </nav>
  </div>
</template>
